// Libraries
import styled from 'styled-components'

type IconProps = {
  active?: boolean
}

export const Button = styled.button<IconProps>`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktopMin}px) {
    display: none;
  }
`

export const Line = styled.hr`
  position: absolute;
  width: 0.3px;
  height: 38px;
  background-color: ${({ theme }) => theme.colors.gray06};
  border: none;
  margin-right: 77px;
`

export const Icon = styled.div<IconProps>`
  display: flex;
  align-items: center;
  width: 18px;
  height: 3px;
  border-radius: 5px;
  background: #000000;
  transform: all 0.2s ease-in-out;
  ${({ active }) => active && `background: transparent;`}
  :before {
    content: '';
    position: absolute;
    width: 18px;
    height: 3px;
    background: #000000;
    border-radius: 5px;
    transition: all 0.2s ease-in-out;
    transform: translateY(-6px);
    ${({ active }) => active && `transform: rotate(45deg) translate(0px);`}
  }
  :after {
    content: '';
    position: absolute;
    width: 18px;
    height: 3px;
    background: #000000;
    border-radius: 5px;
    transition: all 0.2s ease-in-out;
    transform: translateY(6px);
    ${({ active }) => active && `transform: rotate(-45deg) translate(0px);`}
  }
`
